import { render } from "./ClientApartmentCard.vue?vue&type=template&id=71cfaf87"
import script from "./ClientApartmentCard.vue?vue&type=script&lang=js"
export * from "./ClientApartmentCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__